import React, { useState, useEffect } from "react";
import Layout from "../../Layout";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
// import moment from "moment";
import moment from "moment-timezone";

import "react-big-calendar/lib/css/react-big-calendar.css";
import { BiChevronLeft, BiChevronRight, BiPlus, BiTime } from "react-icons/bi";
import { HiOutlineViewGrid } from "react-icons/hi";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import bookingApi from "../../api/booking/BookingApi";
import toast from "react-hot-toast";
import Loading from "../../Util/Loading";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FaRegCalendarAlt } from "react-icons/fa"; // Font Awesome
import { BiCalendarEvent } from "react-icons/bi";
import * as Tooltip from "@radix-ui/react-tooltip";
import { AiOutlineCheckCircle, AiOutlineConsoleSql } from "react-icons/ai";
import staffApi from "../../api/staff/staff.api";
import ProcessingBar2 from "../../components/ProcessingBar/ProcessingBar2";
import { useNavigate } from "react-router-dom";
import Table from "./Table";
import { Empty } from "./Error";
import { MdAssignment, MdCalendarToday, MdCancel } from "react-icons/md";

const localizer = momentLocalizer(moment);

function Appointments() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [booking, setBooking] = useState([]);
  const [staffResources, setStaffResources] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingStaff, setIsLoadingStaff] = useState(true);
  const [cancelled, setCancelled] = useState();

  const getAllBookings = async () => {
    try {
      const { response } = await bookingApi.getAllBookings();

      if (response && response.data) {
        const b = response.data;
        setBooking(b?.booking);
        setCancelled(b?.cancelled);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching bookings:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getAllBookings();
      setIsLoading(false);
    };
    fetchData();
  }, []);

  // console.log({ booking });

  const fetchAndFormatStaffResources = async () => {
    try {
      const { response } = await staffApi.getAllStaffInfo();

      const staffList = response?.data?.data || [];

      // Filter out deleted staff
      const activeStaff = staffList.filter((staff) => staff.isDelete !== "yes");

      return activeStaff.map((staff) => ({
        resourceId: staff._id,
        resourceTitle: (
          <div className="flex flex-col items-center gap-2 m-4">
            <img
              src={staff.photo}
              alt={staff.name}
              className="w-14 h-14 rounded-full object-cover border border-yellowlight p-1"
            />
            <span className="uppercase text-center text-xs font-medium">
              {staff.name}
            </span>
          </div>
        ),
      }));
    } catch (error) {
      console.error("Error fetching staff resources:", error);
      return [];
    }
  };

  const handleDeleteAllBookings = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to delete all bookings?"
    );
    if (!confirmed) return;

    try {
      await bookingApi.deleteAllBookings();
      toast.success("All bookings deleted!");
      await getAllBookings(); // refresh
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete bookings");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingStaff(true);
      await getAllBookings();
      const staff = await fetchAndFormatStaffResources(booking);
      setStaffResources(staff);
      setIsLoadingStaff(false);
    };
    fetchData();
  }, []);

  function stripTimezone(date) {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    );
  }

  const handleClose = () => {
    setOpen(!open);
    setData({});
  };

  const navigate = useNavigate();

  const orders = booking;
  const total = booking?.length;

  const now = new Date();
  const completedBookings =
    orders?.filter((booking) => {
      return (
        booking?.booking?.status === "booked" &&
        new Date(booking.selectedDateTime) < now
      );
    }) || [];

  const Status = [
    {
      bg: "bg-yellow-100",
      icon: MdAssignment,
      color: "text-yellow-500",
      title: "Total Bookings",
      total: total ? total : 0,
    },
    {
      bg: "bg-green-100",
      icon: MdCalendarToday,
      color: "text-green-500",
      title: "Upcoming Bookings",
      total:
        orders?.filter(
          (b) =>
            b?.booking?.status === "booked" &&
            new Date(b.selectedDateTime) >= now
        ).length || 0,
    },
    {
      bg: "bg-red-100",
      icon: MdCancel,
      color: "text-red-500",
      title: "Cancelled Bookings",
      total: cancelled ? cancelled : 0,
    },
    {
      bg: "bg-gray-400",
      icon: AiOutlineCheckCircle,
      color: "text-gray-600",
      title: "Completed Bookings",
      total: completedBookings.length,
    },
  ];

  if (isLoading) return <Loading />;

  return (
    <Layout>
      <div className="flex flex-col gap-4">
        <h2 className="text-xl font-bold text-subMain">List of Booking</h2>
        <div className="grid lg:grid-cols-4 2xl:grid-cols-4 sm:grid-cols-2 gap-3">
          {Status.map((status, i) => (
            <div
              key={i}
              className="p-4 rounded border border-textGray grid grid-cols-4 gap-2"
            >
              <div
                className={`rounded-full col-span-1 text-lg w-12 h-12 flex-colo ${status.bg} ${status.color}`}
              >
                <status.icon />
              </div>
              <div className=" col-span-3">
                <h2 className="text-sm text-textGray">{status.title}</h2>
                <p className="font-bold mt-2 text-white">{status.total}</p>
              </div>
            </div>
          ))}
        </div>
        {orders?.length === 0 ? (
          <div className="flex-colo h-96">
            <Empty text={"No order found"} />
          </div>
        ) : (
          <>
            <div className="flex justify-end mb-4">
              <button
                onClick={handleDeleteAllBookings}
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-semibold"
              >
                Delete All Bookings
              </button>
            </div>
            <Table datas={orders} dashboard={true} />
          </>
        )}
      </div>
    </Layout>
  );
}

export default Appointments;
